export const formatCash = (n) => {
    if (Number.isNaN(n))
        return '-';
    if (n < 1e3)
        return `$${n}`;
    if (n >= 1e3 && n < 1e6)
        return `$${+(n / 1e3).toFixed(1)}K`;
    if (n >= 1e6 && n < 1e9)
        return `$${+(n / 1e6).toFixed(1)}M`;
    if (n >= 1e9 && n < 1e12)
        return `$${+(n / 1e9).toFixed(1)}B`;
    if (n >= 1e12)
        return `$${+(n / 1e12).toFixed(1)}T`;
    return '-';
};
export function formatMoney(value, currency = 'USD', notation = 'compact') {
    if (notation === 'compact' && value >= 1e3)
        return formatCash(value);
    // Create our number formatter.
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        // @ts-ignore
        notation: value < 1e3 ? 'standard' : notation,
        // @ts-ignore
        // minimumFractionDigits: notation === 'compact' ? 2 : 0,
        minimumFractionDigits: notation === 'compact' ? 0 : 0,
        currency,
    });
    // eslint-disable-next-line no-restricted-globals
    return !isNaN(value) && value > 0 ? formatter.format(value) : '-';
}
export function formatNumber(value) {
    return value && value !== '0' ? value : '-';
}
export function formatBigNumber(value) {
    // return value && value !== 0 ? new Intl.NumberFormat().format(value) : '-';
    return new Intl.NumberFormat().format(value);
}
export function parseNumberInput(s) {
    if (s) {
        const b = s.replace(/,/g, '');
        return parseInt(b).toString();
    }
    return null;
}
export function removeMask(maskedValue) {
    return maskedValue ? Number(maskedValue.replace(/[^0-9.-]+/g, '')) : null;
}
